import Immutable from 'immutable';

/**
 * Evaluates if claims match the expected previous claims count and
 * checks that the claim details has been filled
 *
 * caveat: the claims may contain details it used to fill in but are now Dormant.
 *         eg: User selected 2 claims, and fills the form.
 *             When the user selects down to 1 previous claim count,
 *             2 claims are still listed in the driver claim details
 * @param  {Array|Immutable.List} actual         The actual value from state.
 * @param  {string} previousClaimsCount  the current claims count. It is stored as string. Easier to convert it here for some reasons transform doesn't work well
 * @returns {Boolean}          True if matches the count and is all filled.
 */
const claimsMatchesPreviousClaimsCountAndHasClaimDetails = (actual, previousClaimsCount) => {
    // if no value is set at all then the form is not valid yet
    if (previousClaimsCount == null && actual == null) {
        return false;
    }

    const anyPreviousClaimsCount = Number(previousClaimsCount);

    // as long as there are no previous claims we don't need to validate the claim details
    if (anyPreviousClaimsCount === 0) {
        return true;
    }

    if (anyPreviousClaimsCount > 0 && actual == null) {
        return false;
    }

    let claimDetails = Immutable.List.isList(actual) ? claimDetails = actual.toJSON() : actual;

    // will need to check possible nulls first because code further on won't know how to handle nulls in its filter
    if (claimDetails.length === anyPreviousClaimsCount && claimDetails.includes(null)) {
        return false;
    }

    const itMayHaveKeptDormantClaims = claimDetails.length > anyPreviousClaimsCount;

    if (itMayHaveKeptDormantClaims || claimDetails.length === anyPreviousClaimsCount) {
        // Filter the stagedClaimDetails array based on certain conditions
        const currentClaims = claimDetails.filter((item) => item !== null && item.claimNumber <= anyPreviousClaimsCount);

        return !currentClaims.some((claim) => Object.values(claim).includes('')
                || Object.values(claim).includes(undefined)
                || Object.values(claim).includes(null));
    }

    return false;
};

export {
    claimsMatchesPreviousClaimsCountAndHasClaimDetails
};
